'use strict';

export default function($stateProvider) {
  'ngInject';
  $stateProvider
    .state('voter-group-show-ss', {
      url: '/voter-group/ss/:id',
      template: '<voter-group-show-ss></voter-group-show-ss>',
      authenticate: true
    });
}



// WEBPACK FOOTER //
// ./client/app/voter-group/voter-group-show-ss/voter-group-show-ss.routes.js